function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f907fa76-0ba0-4f6b-955c-b91660b941a6{fill:none;}.a0fdc830-001b-4144-afa0-d5e2a62bb18e,.f907fa76-0ba0-4f6b-955c-b91660b941a6{stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}.a0fdc830-001b-4144-afa0-d5e2a62bb18e{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "f907fa76-0ba0-4f6b-955c-b91660b941a6",
  d: "M363.49,346.78l14.61,1.15c32.37,2.53,56.62,29.65,54,60.27L413.9,615.37c-2.7,30.58-31.33,53.56-63.68,51l-14.64-1.15C303.27,662.71,279,635.59,281.66,605l18.15-207.15C302.5,367.22,331.17,344.22,363.49,346.78Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "f907fa76-0ba0-4f6b-955c-b91660b941a6",
  d: "M214.69,340.57l14.61,1.23a59.22,59.22,0,0,1,54,63.72L265.09,624.59a59.21,59.21,0,0,1-63.68,53.95l-14.63-1.21a59.2,59.2,0,0,1-53.92-63.73l18.15-219A59.21,59.21,0,0,1,214.69,340.57Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "f907fa76-0ba0-4f6b-955c-b91660b941a6",
  d: "M503.34,389.31,518,390.43c32.34,2.44,56.6,28.74,53.94,58.38L553.74,649.5c-2.69,29.65-31.33,51.91-63.7,49.44l-14.58-1.1c-32.35-2.46-56.64-28.73-53.93-58.39l18.15-200.71C442.34,409.1,471,386.85,503.34,389.31Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "f907fa76-0ba0-4f6b-955c-b91660b941a6",
  d: "M650.51,451.07l14.5,1.87c32.19,4.15,54.86,32.11,50.44,62.15L692.19,672.92c-4.43,30.08-34.34,51.26-66.5,47.12l-14.53-1.86C579,714,556.33,686.06,560.76,656L584,498.18C588.42,468.14,618.37,446.93,650.51,451.07Z"
});

var _ref7 = /*#__PURE__*/React.createElement("polyline", {
  className: "f907fa76-0ba0-4f6b-955c-b91660b941a6",
  points: "715 519.82 696.7 827.78 592.52 1056.25"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "a0fdc830-001b-4144-afa0-d5e2a62bb18e",
  d: "M382.91,931.49C370.57,808.68,206.54,754.08,206.54,754.08L193,697l77.61-53.93c30.49-24.74,34.26-66.45,14-102.79-15.92-28.43-48.86-17-48.86-17S90.3,559,58.88,579.69C-8.57,624.05,40.94,793.3,68.33,845.08s104.58,211.19,104.58,211.19l16.79,75.78"
});

function SvgLeft0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aa98b5c5-d992-4a85-a82b-764769886a94",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 741 1157.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft0);
export default __webpack_public_path__ + "static/media/left-0.e37a0a62.svg";
export { ForwardRef as ReactComponent };